import { useEffect } from "react";
import { siteMeta } from "../mocks/gossip";

interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
  path?: string;
  type?: string;
}

const base = "https://qihang77.cn";

export default function useSeo(options: SeoOptions) {
  const { title, description, keywords = siteMeta.name, path = "/", type = "website" } = options;

  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    setMeta("keywords", keywords);
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = `${base}${path === "/" ? "/" : path}`;
    setOg("og:title", title);
    setOg("og:description", description);
    setOg("og:type", type);
    setOg("og:url", `${base}${path === "/" ? "/" : path}`);
  }, [title, description, keywords, path, type]);
}

function setMeta(attr: string, content: string) {
  let el = document.querySelector(`meta[name="${attr}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.name = attr;
    document.head.appendChild(el);
  }
  el.content = content;
}

function setOg(prop: string, content: string) {
  let el = document.querySelector(`meta[property="${prop}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", prop);
    document.head.appendChild(el);
  }
  el.content = content;
}